export const NoContainers = ({ className }: { className?: string }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    className={className}
  >
    <path d="M19.6667 15.5H41.8333V29.9737H19.6667V15.5Z" fill="#B2ABAB" />
    <path d="M42.4167 15.5H50.5542L60.5 29.9737H42.4167V15.5Z" fill="#B2ABAB" />
    <path d="M19.0833 15.5H4.5V29.9737H19.0833V15.5Z" fill="#B2ABAB" />
    <path
      d="M4.5 30.5526H60.5L42.4355 48.5H14.7667L4.5 30.5526Z"
      fill="#B2ABAB"
    />
  </svg>
);
